const CSS_RESET = {
  hr: {
    borderTopWidth: "1px",
    boxSizing: "content-box",
    height: 0,
    overflow: "visible",
    margin: 0
  },
  a: {
    backgroundColor: "transparent",
    color: "inherit",
    textDecoration: "inherit"
  },
  ":where(b, strong)": {
    fontWeight: "bold"
  },
  ":where(ol, ul)": {
    padding: 0
  },
  ":where(img, video, canvas, audio, iframe, embed, object)": {
    display: "block"
  },
  ":where(pre, code, kbd, samp)": {
    fontFamily: "SFMono-Regular, Menlo, Monaco, Consolas, monospace",
    fontSize: "1em"
  },
  ":where(*, *::before, *::after)": {
    borderWidth: 0,
    borderStyle: "solid",
    boxSizing: "border-box",
    wordWrap: "break-word"
  },
  ":where(blockquote, dl, dd, h1, h2, h3, h4, h5, h6, hr, figure, p, pre, ol, ul)": {
    margin: 0
  },
  ":where(button, input, optgroup, select, textarea)": {
    fontFamily: "inherit",
    fontSize: "100%",
    lineHeight: "inherit",
    margin: 0,
    color: "inherit"
  },
  ":where(button, input)": {
    overflow: "visible"
  },
  ":where(button, select)": {
    textTransform: "none"
  },
  ':where(button, [role="button"])': {
    cursor: "pointer"
  },
  ":where(h1, h2, h3, h4, h5, h6)": {
    fontSize: "inherit",
    fontWeight: "inherit"
  },
  table: {
    borderCollapse: "collapse"
  },
  template: {
    display: "none"
  },
  summary: {
    display: "list-item"
  },
  details: {
    display: "block"
  },
  legend: {
    boxSizing: "border-box",
    color: "inherit",
    display: "table",
    maxWidth: "100%",
    padding: 0,
    whiteSpace: "normal"
  },
  fieldset: {
    padding: "0.35em 0.75em 0.625em"
  },
  "[hidden]": {
    display: "none !important"
  },
  "[data-js-focus-visible]:focus:not([data-focus-visible-added]):not([data-focus-visible-disabled])": {
    outline: "none",
    boxShadow: "none"
  }
};

export { CSS_RESET };
